/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { createPortal } from "react-dom";

const Portal = ({ children }) => {
  const mount = document.getElementById("portal-root")!;

  return createPortal(children, mount);
};

export default Portal;
